import { inject } from '@angular/core';
import type { CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { Router } from '@angular/router';
import { ImportRouterStateKey } from '../enums/import-router-state-key';

export const importGuard: CanActivateFn = (
  _,
  snapshot: RouterStateSnapshot,
) => {
  const router = inject(Router);

  const state = router.currentNavigation()?.extras?.state;
  for (const key of Object.values(ImportRouterStateKey)) {
    if (state?.[key] != null) continue;
    return router.parseUrl(snapshot.url.replace(/\/import$/, ''));
  }

  return true;
};
